import React from 'react'
import isBoolean from 'lodash/isBoolean'

import { Tag } from 'Shared/atoms'

interface YesNoLabelProps {
	value: boolean | null
	isActiveLabels?: boolean
}

const YesNoLabel: React.FC<YesNoLabelProps> = ({ value, isActiveLabels }) => {
	const yesLabel = isActiveLabels ? 'Active' : 'YES'
	const noLabel = isActiveLabels ? 'Inactive' : 'NO'

	if (!isBoolean(value)) {
		return null
	}

	return (
		<Tag
			type={Boolean(value) ? 'green' : 'disabled'}
			size={isActiveLabels ? 'm' : 's'}
			isSingle
		>
			{value ? yesLabel : noLabel}
		</Tag>
	)
}

export default YesNoLabel
